import { Response } from "react-select-async-paginate";
import AsyncPaginateBootstrap from "../react-select-bootstrap/AsyncPaginateBootstrap";
import { getList } from "../../api/generics";
import { useSelector } from "react-redux";
import { RootState } from "../../store";
import Asset from "../../models/asset";

const RECORS_PER_SEARCH = 20;

type AssetSelectProps = {
  value: Asset | null;
  disabled?: boolean;
  onlyParents?: boolean;
  onChange: (_: Asset | null) => void;
};

const AssetSelect: React.FC<AssetSelectProps> = ({
  value,
  disabled,
  onChange,
  onlyParents,
}) => {
  const companyId = useSelector(
    (state: RootState) => state.company.data.company.id
  );
  const loadOptions = async (
    s: string,
    currentOpts: readonly (Asset | { options: Asset[]; label?: string })[]
  ): Promise<Response<Asset, { options: Asset[]; label?: string }, any>> => {
    let additionalParams: Map<string, string> | undefined = new Map<
      string,
      string
    >();

    additionalParams.set("company_id", companyId!.toString());

    if (s !== "") {
      additionalParams.set("search", s);
    }

    if (onlyParents) {
      additionalParams.set("only_parents", "true");
    }

    const dataPaginated = await getList<Asset>(
      "/assets/",
      RECORS_PER_SEARCH,
      currentOpts.length,
      additionalParams
    );

    let newOpts: Asset[] = [];
    let count = 0;

    if (dataPaginated.data !== undefined) {
      newOpts = dataPaginated.data.items;
      count = dataPaginated.data.count;
    }

    const hasMore = currentOpts.length + newOpts.length < count;

    return {
      options: newOpts,
      hasMore: hasMore,
    };
  };
  return (
    <AsyncPaginateBootstrap
      placeholder={"Seleccciona el activo"}
      onChange={onChange}
      isMulti={false}
      debounceTimeout={300}
      loadOptions={loadOptions}
      getOptionLabel={(option: Asset) => `${option.name}`}
      getOptionValue={(option: Asset) => `${option.id}`}
      value={value}
      isDisabled={disabled}
      isClearable={true}
    />
  );
};

export default AssetSelect;
